import React, {Component} from 'react';
import {SignupForm} from './signup-form'

import './signup.css';

class Signup extends Component {

  render() {
    let data = this.props.data;
    let instruction = data.instruction ? data.instruction : null;

    return (
      <div style={{marginTop: "-5"}}>

        <div className="signup-bulletin">
          <em> {instruction} </em>
        </div>

        <div style={{paddingBottom: '30px'}}>
          <SignupForm data = {data.form}></SignupForm>
        </div>

      </div>
    );
  }
}

export default {Signup}



// WEBPACK FOOTER //
// ./src/components/Signup/index.js